import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { formatEpisodeResponse, computeDiagnosisData } from '@/lib/utils/episodesAndTreatmentSets';
import PatientDataUtil from '@/lib/utils/PatientDataUtil';
import axios, { AxiosError } from 'axios';
import { formatServerityConditions } from '@/lib/utils/episodesAndTreatmentSets';
import { getReconData } from '@/lib/utils/episodesAndTreatmentSets';
import { clearError } from './errorSlice';
import { handleApiError } from '@/utils/apiErrorHandler';

export const fetchEpisodeDescription = createAsyncThunk(
  'cost/fetchEpisodeDescription',
  async ({ mpin, size, severity, patientID, benchmark, reconCaseID, sort, isDelegate }:
    {
      mpin: string,
      size: number,
      severity?: string,
      patientID?: string,
      benchmark?: string,
      reconCaseID?: string,
      sort: string,
      isDelegate?: boolean
    }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-description?size=${size}&sort=${sort}` :
      `/papi/secure/physician/${mpin}/cost/episode-description?size=${size}&sort=${sort}`;
    if (severity) url = `${url}&severity=${severity}`;
    if (patientID) url = `${url}&patientID=${patientID}`;
    if (benchmark) url = `${url}&benchmark=${benchmark}`;
    if (reconCaseID) url = `${url}&reconCaseID=${reconCaseID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-description fetch from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeDescription:', response);
      return response.data;
    } catch (error) {


    }
  });

export const fetchEpisodeSeverites = createAsyncThunk(
  'cost/fetchEpisodeSeverites',
  async ({ mpin, size, sort, description, patientID, benchmark, reconCaseID, isDelegate }:
    {
      mpin: string;
      size: number,
      sort: string,
      description?: string,
      patientID?: string,
      benchmark?: string,
      reconCaseID?: string,
      isDelegate?: boolean
    }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-severities?size=${size}&sort=${sort}` :
      `/papi/secure/physician/${mpin}/cost/episode-severities?size=${size}&sort=${sort}`;
    if (description) url = `${url}&description=${description}`;
    if (patientID) url = `${url}&patientID=${patientID}`;
    if (benchmark) url = `${url}&benchmark=${benchmark}`;
    if (reconCaseID) url = `${url}&reconCaseID=${reconCaseID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-severites fetch from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeSeverites:', response);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const fetchEpisodePatients = createAsyncThunk('cost/fetchEpisodePatients',
  async ({ mpin, size, sort, description, severity, benchmark, reconCaseID, isDelegate }:
    {
      mpin: string,
      size: number,
      sort: string,
      description?: string,
      benchmark?: string,
      reconCaseID?: string
      severity?: string,
      isDelegate: boolean
    }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-patients?size=${size}&sort=${sort}` :
      `/papi/secure/physician/${mpin}/cost/episode-patients?size=${size}&sort=${sort}`;
    if (description) url = `${url}&description=${description}`;
    if (severity) url = `${url}&severity=${severity}`;
    if (benchmark) url = `${url}&benchmark=${benchmark}`;
    if (reconCaseID) url = `${url}&reconCaseID=${reconCaseID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-patients fetch from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodePatients:', response);
      return response?.data?.data;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });


export const fetchEpisodes = createAsyncThunk('cost/fetchEpisodes',
  async ({ mpin, page, size, sort, description, severity, patientID, benchmark, reconCaseID, section, isDelegate, isCaseClosed, changeRequestApplied }:
    {
      mpin: string;
      page: number;
      size: number;
      sort: string,
      patientID?: string,
      severity?: string,
      description?: string,
      benchmark?: string,
      reconCaseID?: string,
      section?: string,
      isDelegate?: boolean,
      isCaseClosed: boolean,
      changeRequestApplied?: string
    }, { dispatch }) => {
    let url = '';
    if (isCaseClosed) {
      url = !isDelegate ? `/papi/secure/case/episodes?page=${page}&size=${size}&sort=${sort}` :
        `/papi/secure/physician/${mpin}/case/episodes?page=${page}&size=${size}&sort=${sort}`;
    } else {
      url = !isDelegate ? `/papi/secure/cost/episodes?page=${page}&size=${size}&sort=${sort}` :
        `/papi/secure/physician/${mpin}/cost/episodes?page=${page}&size=${size}&sort=${sort}`;
    }
    if (description) url = `${url}&description=${description}`;
    if (severity) url = `${url}&severity=${severity}`;
    if (patientID) url = `${url}&patientID=${patientID}`;
    if (benchmark) url = `${url}&benchmark=${benchmark}`;
    if (reconCaseID) url = `${url}&reconCaseID=${reconCaseID}`;
    if (section) url = `${url}&section=${section}`;
    if (changeRequestApplied) url = `${url}&changeRequestApplied=${changeRequestApplied}`

    try {
      dispatch(clearError());
      console.log('routeUrl cost/episodes fetch from:', url);
      const response = await axios.get(url);

      console.log('routeUrl cost/episodes fetch from:', url);
      return { data: response?.data?.data, variant: size === 5000 ? 'dropdown' : 'table', totalItems: response?.data?.totalItems }
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const fetchEpisodeAttributionPeg = createAsyncThunk(
  'cost/fetchEpisodeAttributionPeg',
  async ({ mpin, page, size, sort, episodeID, isDelegate }:
    { mpin: string; page: number; size: number; sort: string, episodeID: string, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-peg-attribution?page=${page}&size=${size}&sort=${sort}&episodeID=${episodeID}` :
      `/papi/secure/physician/${mpin}/cost/episode-peg-attribution?page=${page}&size=${size}&sort=${sort}&episodeID=${episodeID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-peg-attribution get from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeAttributionPeg:', response);
      return { data: response?.data?.data, totalItems: response?.data?.totalItems };
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const fetchEpisodeAttributionEbm = createAsyncThunk(
  'cost/fetchEpisodeAttributionEbm',
  async ({ mpin, episodeID, isDelegate }:
    { mpin: string; episodeID: string, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-ebm-attribution?episodeID=${episodeID}` :
      `/papi/secure/physician/${mpin}/cost/episode-ebm-attribution?episodeID=${episodeID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-ebm-attribution get from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeAttributionEbm:', response);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const fetchEpisodeServiceDetails = createAsyncThunk(
  'cost/fetchEpisodeServiceDetails',
  async ({ mpin, page, size, sort, direction, episodeID, isDelegate }:
    { mpin: string; page: number; size: number; sort: string, episodeID: string, direction: string, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-service-details?page=${page}&size=${size}&sort=${sort},${direction}&episodeID=${episodeID}` :
      `/papi/secure/physician/${mpin}/cost/episode-service-details?page=${page}&size=${size}&sort=${sort},${direction}&episodeID=${episodeID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-service-details get from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeServiceDetails:', response);
      return { data: response?.data?.data, totalItems: response?.data?.totalItems };
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const fetchEpisodeSeverityCondtions = createAsyncThunk(
  'cost/fetchEpisodeSeverityCondtions',
  async ({ mpin, size, episodeID, isDelegate }: { mpin: string, size: number, episodeID: string, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-severity-conditions?size=${size}&episodeID=${episodeID}` :
      `/papi/secure/physician/${mpin}/cost/episode-severity-conditions?size=${size}&episodeID=${episodeID}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-severity-conditions get from:', url);
      const response = await axios.get(url);
      console.log('response in fetchEpisodeSeverityCondtions:', response);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeExclusionGet = createAsyncThunk(
  'cost/episodeExclusionGet', async ({ mpin, size, sort, episodeID, isDelegate, reconCaseSystemID }:
    { mpin: string, size: number, episodeID: string, sort: string, isDelegate: boolean, reconCaseSystemID?: string }, { dispatch }) => {
  let url = !isDelegate ? `/papi/secure/cost/episode-exclusion?size=${size}&episodeID=${episodeID}&sort=${sort}` :
    `/papi/secure/physician/${mpin}/cost/episode-exclusion?size=${size}&episodeID=${episodeID}&sort=${sort}`;
  if (reconCaseSystemID) url += `&reconCaseSystemID=${reconCaseSystemID}`;
  try {
    dispatch(clearError());
    console.log('routeUrl cost/episode-exclusion get from:', url);
    const response = await axios.get(url);
    console.log('response in episodeExclusionGet:', response);
    return { data: response?.data?.data, episodeID: episodeID };
  } catch (error) {
    handleApiError(error as AxiosError, "cost", dispatch);
    throw error;
  }
});

export const episodeExclusionPost = createAsyncThunk(
  'cost/episodeExclusionPost',
  async ({ mpin, payload, update, isDelegate }: { mpin: string, payload: any, update: boolean, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-exclusion` :
      `/papi/secure/physician/${mpin}/cost/episode-exclusion`;
    if (update) {
      url += `?update=${update}`;
    }
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-exclusion post from:', url);
      const response = await axios.post(url, payload);
      console.log('response in episodeExclusionPost:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeExclusionDelete = createAsyncThunk(
  'cost/episodeExclusionDelete',
  async ({ mpin, episodeID, patientID, conditions, isDelegate }:
    { mpin: string, patientID: string, episodeID: string, conditions: Array<any>, isDelegate: boolean }, { dispatch }) => {
    const url = !isDelegate ? `/papi/secure/cost/episode-exclusion/remove` :
      `/papi/secure/physician/${mpin}/cost/episode-exclusion/remove`;
    try {
      dispatch(clearError());
      const response = await axios.post(url, { episodeID, patientID, conditions });
      console.log('response in episodeExclusionPost:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const severityExclusionPost = createAsyncThunk(
  'cost/episodeExclusionPost',
  async ({ mpin, payload, update, isDelegate }: { mpin: string, payload: any, update: boolean, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-severity-exclusion` :
      `/papi/secure/physician/${mpin}/cost/episode-severity-exclusion`;
    if (update) {
      url += `?update=${update}`;
    }
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-severity-exclusion post from:', url);
      const response = await axios.post(url, payload);
      console.log('response in episodeSeverityExclusionPost:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const severityExclusionDelete = createAsyncThunk(
  'cost/severityExclusionDelete',
  async ({ mpin, episodeID, patientID, conditions, isDelegate }:
    { mpin: string, patientID: string, episodeID: string, conditions: Array<any>, isDelegate: boolean }, { dispatch }) => {
    const url = !isDelegate ? `/papi/secure/cost/episode-severity-exclusion/remove` :
      `/papi/secure/physician/${mpin}/cost/episode-severity-exclusion/remove`;

    try {
      dispatch(clearError());
      const response = await axios.post(url, { episodeID, patientID, conditions });
      console.log('response in severityExclusionDelete:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeServiceDetailsExlusionGet = createAsyncThunk('cost/episodeServiceDetailsExlusionGet',
  async ({ mpin, page, size, sort, direction, episodeID, reconFlag, reconCaseID, isDelegate }:
    { mpin: string; page: number; size: number; sort: string, episodeID: string, direction: string, reconFlag?: number, reconCaseID?: string, isDelegate: boolean }, { dispatch }) => {
    const base = !isDelegate
      ? `/papi/secure/cost/episode-service-details?page=${page}&size=${size}&sort=${sort},${direction}&episodeID=${episodeID}`
      : `/papi/secure/physician/${mpin}/cost/episode-service-details?page=${page}&size=${size}&sort=${sort},${direction}&episodeID=${episodeID}`;
    // prefer reconCaseID when available (closed case), fall back to reconFlag
    const url = reconCaseID ? `${base}&reconCaseID=${reconCaseID}` : `${base}&reconFlag=${reconFlag}`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-service-details get from:', url);
      const response = await axios.get(url);
      console.log('response in episodeExclusionPost:', response);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeServiceDetailsExlusionPost = createAsyncThunk('cost/episodeServiceDetailsExlusionPost',
  async ({ mpin, payload, update, isDelegate }: { mpin: string; payload: any, update: boolean, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-service-details-exclusion` :
      `/papi/secure/physician/${mpin}/cost/episode-service-details-exclusion`;
    if (update) {
      url += `?update=${update}`;
    }
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-service-exclusion post from:', url);
      const response = await axios.post(url, payload);
      console.log('response in episodeServiceDetailsExlusionPost:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeServiceDetailsExlusionDelete = createAsyncThunk('cost/episodeServiceDetailsExlusionDelete',
  async ({ mpin, patientID, episodeID, episodeDetailSystemID, isDelegate }: { mpin: string; patientID: string, episodeID: string, episodeDetailSystemID: string, isDelegate: boolean }, { dispatch }) => {
    const url = !isDelegate ? `/papi/secure/cost/episode-service-details-exclusion/remove` :
      `/papi/secure/physician/${mpin}/cost/episode-service-details-exclusion/remove`;
    try {
      dispatch(clearError());
      const response = await axios.post(url, { episodeID, patientID, episodeDetailSystemID });
      console.log('response in episodeServiceDetailsExlusionDelete:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeEvalutionExlusionPost = createAsyncThunk('cost/episodeEvalutionExlusionPost',
  async ({ mpin, payload, update, isDelegate }: { mpin: string; payload: any, update: boolean, isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost/episode-exclusion` :
      `/papi/secure/physician/${mpin}/cost/episode-exclusion`;
    if (update) {
      url += `?update=${update}`;
    }
    try {
      dispatch(clearError());
      const response = await axios.post(url, payload);
      console.log('response in episodeServiceDetailsExlusionDelete:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeEvalutionExlusionDelete = createAsyncThunk('cost/episodeEvalutionExlusionDelete',
  async ({ mpin, patientID, episodeID, isDelegate }: { mpin: string; patientID: string, episodeID: string, isDelegate: boolean }, { dispatch }) => {
    const url = !isDelegate ? `/papi/secure/cost/episode-exclusion/remove` :
      `/papi/secure/physician/${mpin}/cost/episode-exclusion/remove`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/episode-exclusion remove from:', url);
      const response = await axios.post(url, { episodeID, patientID });
      console.log('response in episodeEvalutionExlusionDelete:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeReconAttachmentPost = createAsyncThunk(
  'cost/episodeReconAttachmentPost',
  async ({ mpin, payload, isDelegate }: { mpin: string; payload: any; isDelegate: boolean }, { dispatch }) => {
    let url = !isDelegate ? `/papi/secure/cost-episode/recon/attachment` :
      `/papi/secure/physician/${mpin}/cost-episode/recon/attachment`;
    try {
      dispatch(clearError());
      console.log('routeUrl cost/cost-episode/recon/attachment post from:', url);
      const response = await axios.post(url, payload);
      console.log('response in episodeReconAttachmentPost:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });

export const episodeReconAttachmentDelete = createAsyncThunk(
  'cost/episodeReconAttachmentDelete',
  async ({ mpin, patientID, episodeID, isDelegate }: { mpin: string; patientID: string, episodeID: string, isDelegate: boolean }, { dispatch }) => {
    const url = !isDelegate ? `/papi/secure/cost-episode/recon/attachment/remove` :
      `/papi/secure/physician/${mpin}/cost-episode/recon/attachment/remove`;

    try {
      dispatch(clearError());
      console.log('routeUrl cost/cost-episode/recon/attachment remove from:', url);
      const response = await axios.post(url, { episodeID, patientID });
      console.log('response in episodeReconAttachmentDelete:', response);
      return response.status;
    } catch (error) {
      handleApiError(error as AxiosError, "cost", dispatch);
      throw error;
    }
  });


// Create slice
const costSlice = createSlice({
  name: 'cost',
  initialState: {
    adjudication: {
      decision: '',
      informationConsidered: ''
    },
    caseData: [],
    data: [],
    loading: false,
    totalItems: 0,
    patients: [],
    descriptions: [],
    severities: [],
    attributionEbm: {
      data: {
        yourPercentage: 0,
        othersPercentage: 0
      }, loading: false
    },
    attribution: {
      attributions: [],
      loading: false,
      totalItems: 0
    },
    serviceDetails: {
      services: [] as any[],
      loading: false,
      serviceDetailsRow: {},
      totalItems: 0
    },
    severityConditions: {
      conditions: {},
      loading: false
    },
    severityDetails: {
      exclusion: {}, // Explicitly define the type
      loading: false
    },
    exclusionServiceDetails: {
      serviceExlusions: [],
      serviceExclusionsInfos: [],
      loading: false,
      totalItems: 0,
    },
    reconModalData: {}
  },
  reducers: {
    setReconModalData: (state, action) => {
      state.reconModalData = action.payload;
    },
    setServiceDetailsRow: (state, action) => {
      state.serviceDetails.serviceDetailsRow = action.payload;
    },
    setEpisodeServiceDetails: (state, action) => {
      const findIndex = state.serviceDetails.services.findIndex((item: any) => item.systemID === action.payload.systemID);
      if (findIndex !== -1) {
        state.serviceDetails.services[findIndex] = {
          ...state.serviceDetails.services[findIndex],
          ...action.payload
        };
      }
    },
    setEpisodeDetails: (state, action) => {
      const { episodeID, hasRecon } = action.payload;
      state.data = state.data?.map((item: { id: string; reconFlag?: boolean }) =>
        item.id === episodeID
          ? { ...item, reconFlag: hasRecon }
          : item
      );
    },
    clearCostInfo: (state) => {
      state.totalItems = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEpisodePatients.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.patients = [];
      })
      .addCase(fetchEpisodePatients.fulfilled, (state, action) => {
        state.loading = false;
        state.patients = action.payload;
      })
      .addCase(fetchEpisodePatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeSeverites.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.severities = [];
      })
      .addCase(fetchEpisodeSeverites.fulfilled, (state, action) => {
        state.loading = false;
        state.severities = action.payload.data;
      })
      .addCase(fetchEpisodeSeverites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeDescription.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.descriptions = [];
      })
      .addCase(fetchEpisodeDescription.fulfilled, (state, action) => {
        state.loading = false;
        state.descriptions = action.payload.data;
      })
      .addCase(fetchEpisodeDescription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodes.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        const { size } = action.meta.arg;
        // You can derive type from size if needed
        const type = size === 10 ? 'table' : 'dropdown';

        // Example usage:
        if (type === 'dropdown') {
          state.patients = [];
        } else {
          state.data = [];
        }
      })
      .addCase(fetchEpisodes.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload.variant === 'dropdown') {
          state.patients = action.payload.data;
        } else {
          state.data = formatEpisodeResponse(action?.payload?.data?.costEpisodes),
            state.totalItems = action.payload.totalItems;
        }
      })
      .addCase(fetchEpisodes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeAttributionPeg.pending, (state) => {
        state.attribution.loading = true;
        state.error = null;
        state.attribution.attributions = [];
      })
      .addCase(fetchEpisodeAttributionPeg.fulfilled, (state, action) => {
        const service = action.payload?.data?.map((item: any) => {
          return {
            ...item,
            diagnosesData: computeDiagnosisData(item),
          };
        });
        state.attribution.loading = false;
        state.attribution.attributions = service;
        state.attribution.totalItems = action.payload.totalItems;
      })
      .addCase(fetchEpisodeAttributionPeg.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeServiceDetails.pending, (state) => {
        state.serviceDetails.loading = true;
        state.error = null;
        state.serviceDetails.services = [];
      }
      )
      .addCase(fetchEpisodeServiceDetails.fulfilled, (state, action) => {
        const service = action.payload?.data?.map((item: any) => {
          return {
            ...item,
            diagnosesData: computeDiagnosisData(item),
            providerFullName: `${item?.providerFirstName} ${item?.providerLastName}`,
          };
        });
        state.serviceDetails.loading = false;
        state.serviceDetails.services = service;
        state.serviceDetails.totalItems = action.payload.totalItems;
      }
      )
      .addCase(fetchEpisodeServiceDetails.rejected, (state, action) => {
        state.serviceDetails.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeSeverityCondtions.pending, (state) => {
        state.severityConditions.loading = true;
        state.error = null;
        state.severityConditions.conditions = {};
      }
      )
      .addCase(fetchEpisodeSeverityCondtions.fulfilled, (state, action) => {
        const conditions = formatServerityConditions(action.payload?.data);
        state.severityConditions.loading = false;
        state.severityConditions.conditions = { ...conditions };
      }
      )
      .addCase(fetchEpisodeSeverityCondtions.rejected, (state, action) => {
        state.severityConditions.loading = false;
        state.error = action.error.message;
      })
      .addCase(episodeExclusionGet.pending, (state) => {
        state.severityDetails.loading = true;
        state.error = null;
      }
      )
      .addCase(episodeExclusionGet.fulfilled, (state, action) => {
        if (!action.payload?.data || action.payload?.data?.length === 0) {
          state.severityDetails.exclusion = {};
          state.severityDetails.loading = false;
          state.exclusionServiceDetails.serviceExclusionsInfos = [];
          return;
        }
        const fields = {
          selectedIDFieldName: 'selectedEpisodeId',
          selectedID: action.payload.episodeID,
          reasonDescriptionName: 'reconEfficiencyEpisodeDescription',
          svcDetailsIDField: 'efficiencyStaticEpisodeDetailSystemID',
          svcDetailsDescField: 'reconEfficiencyEpisodeServiceDescription',
          severityOrRiskDescriptionField: 'reconEfficiencyEpisodeSeverityDescription',
          severityOrRiskStateVariableName: 'severityExclusions'
        }
        state.severityDetails.loading = false;
        const lastIndex = action?.payload?.data?.length - 1;
        const lastItem = lastIndex >= 0 ? action?.payload?.data[lastIndex] : {};
        state.exclusionServiceDetails.serviceExclusionsInfos = action?.payload?.data;
        state.severityDetails.exclusion = getReconData([lastItem], fields);
      }
      )
      .addCase(episodeExclusionGet.rejected, (state, action) => {
        state.exclusionServiceDetails.serviceExclusionsInfos = [];
        state.severityDetails.loading = false;
        state.error = action.error.message;
      })
      .addCase(episodeServiceDetailsExlusionGet.pending, (state) => {
        state.exclusionServiceDetails.loading = true;
        state.error = null;
        state.exclusionServiceDetails.serviceExlusions = [];
      }
      )
      .addCase(episodeServiceDetailsExlusionGet.fulfilled, (state, action) => {
        const service = action.payload?.data?.map((item: any) => {
          return {
            ...item,
            diagnosesData: computeDiagnosisData(item),
            providerFullName: `${item?.providerFirstName} ${item?.providerLastName}`,
          };
        });
        state.exclusionServiceDetails.loading = false;
        state.exclusionServiceDetails.serviceExlusions = service;
        state.exclusionServiceDetails.totalItems = action.payload.totalItems;
      }
      )
      .addCase(episodeServiceDetailsExlusionGet.rejected, (state, action) => {
        state.exclusionServiceDetails.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEpisodeAttributionEbm.rejected, (state, action) => {
        state.attributionEbm.loading = false;
        state.error = action.error.message;
      }
      )
      .addCase(fetchEpisodeAttributionEbm.pending, (state) => {
        state.attributionEbm.loading = true;
        state.error = null;
        state.attributionEbm.data = { yourPercentage: 0, othersPercentage: 0 };
      }
      )
      .addCase(fetchEpisodeAttributionEbm.fulfilled, (state, action) => {
        state.attributionEbm.loading = false;
        state.attributionEbm.data = action.payload.data;
      }
      )
  },
});

export const {
  setReconModalData,
  setEpisodeServiceDetails,
  setServiceDetailsRow,
  setEpisodeDetails,
  clearCostInfo
} = costSlice.actions;

export default costSlice.reducer;
